




import shelf from "@/store/idb/shelf"
import { defineComponent, ref } from "@vue/composition-api";
import { routerStore } from "@/store/routerStore";
import loader from "@/config/loader"
export default defineComponent({
  setup() {
    const fileName = routerStore.pwd
    const raw = ref("Loading")
    shelf.open().query(fileName).then(res => {
      const html = loader(fileName, res) as string
      raw.value =  html
    })
    return {
        raw
    }
  }
});
